import { getColorForScore, ScoreColor } from '@/ui/utils/get-color-for-score';

export function ScoreToColor() {
  return (
    <div>
      {['A', 'B', 'C', 'D', 'E', 'R'].map((score) => (
        <p key={score}>
          {score} : <Square color={getColorForScore(score)} />
        </p>
      ))}
    </div>
  );
}

export function Square({ color }: { color: ScoreColor }) {
  return (
    <span>
      <span
        style={{
          color: color.text,
          backgroundColor: color.main,
          width: 10,
          height: 10,
          padding: 5,
          margin: 5,
          fontWeight: 'bold',
        }}
      >
        MAIN
      </span>
      <span
        style={{
          color: color.main,
          backgroundColor: color.secondary,
          width: 10,
          height: 10,
          padding: 5,
          margin: 5,
          fontWeight: 'bold',
        }}
      >
        SECONDARY
      </span>
    </span>
  );
}
